var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1111 2H10.8889V3.11111H13.1111V2ZM10.8889 3.11133H8.66669V4.22244H10.8889V3.11133ZM6.44446 4.22266H8.66668V5.33377H6.44446V4.22266ZM6.44445 5.33301H4.22223V6.44412H6.44445V5.33301ZM4.22223 7.55566H6.44445V8.66677H4.22223V7.55566ZM8.66668 8.66699H6.44446V9.7781H8.66668V8.66699ZM8.66669 9.77734H10.8889V10.8885H8.66669V9.77734ZM15.3333 3.11133H13.1111V4.22244H15.3333V3.11133ZM15.3333 4.22266H17.5555V5.33377H15.3333V4.22266ZM19.7778 5.33301H17.5555V6.44412H19.7778V5.33301ZM17.5556 7.55545H19.7778V6.44434H22V7.55545V16.4443V17.5554H19.7778V18.6666H17.5556V19.7777H15.3334V20.8888H13.1111V21.9999H10.8889V20.8888H12V11.9999H10.8889V10.8888H13.1111V9.77767H15.3334V8.66656H17.5556V7.55545ZM3.11111 16.4443V7.55545H4.22222V6.44434H2V7.55545V16.4443V17.5554H4.22222V16.4443H3.11111ZM4.22223 17.5557H6.44445V18.6668H4.22223V17.5557ZM8.66668 18.667H6.44446V19.7781H8.66668V18.667ZM8.66669 19.7773H10.8889V20.8885H8.66669V19.7773Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxM);
export default __webpack_public_path__ + "static/media/box-m.2cd93983859fc5598a064554f95c974f.svg";
export { ForwardRef as ReactComponent };